import { Injectable } from '@angular/core';
import { LoderService } from './loder.service';
import { HttpHandler, HttpRequest, HttpEvent, HttpResponse, HttpInterceptor } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { CookieService } from 'ngx-cookie-service';
import { Router } from '@angular/router';
import { AuthService } from './auth.service';
import { ToastrService } from 'ngx-toastr';
import { EncryptDecryptService } from './encrypt-decrypt.service';
import { switchMap, filter, take } from 'rxjs/operators';
import { BehaviorSubject, throwError, Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthInterceptorService implements HttpInterceptor {
  private isRefreshing = false;
  private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  constructor(private authService: AuthService, private cookies: CookieService, private toastrService: ToastrService, private enc: EncryptDecryptService) { }
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let authReq = req;
    const localToken: any = localStorage.getItem(this.enc.encryptUsingAES256('ESS_token'));
    const sessionToken: any = sessionStorage.getItem(this.enc.encryptUsingAES256('ESS_token'));
    if (localToken && localToken.length && localToken.length > 0 && sessionToken && sessionToken.length && sessionToken.length > 0) {
      if (localToken !== sessionToken) {
        this.authService.logout();
        this.toastrService.error('unauthorized');
      }
    }
    if (sessionToken && req.url.indexOf('/Auth/authenticate') === -1 && req.url.indexOf('/Auth/RefreshToken') === -1) {
      authReq = this.addToken(req, sessionToken);
    }
    return next.handle(authReq).pipe(catchError(err => {
      if (err.status === 401) {
        // this.toastrService.error(err.statusText);
        // // auto logout if 401 response returned from API
        // this.authService.logout();
        // // location.reload(true);
        // const error = err.error.message || err.statusText;
        // return throwError(error);
        return this.handle401Error(authReq, next);
      } else if (err.status === 400) {
        var msg = '';
        for (let json in err.error.errors) {
          var jsonParam = json.replace('$.', '');
          msg = msg.concat(jsonParam + ', ');
        }
        this.toastrService.error(msg);
        return of(new HttpResponse({ body: [] }));
      } else if (err.status === 404) { // Not Found
        this.toastrService.error("Not Found");
        return of(new HttpResponse({ body: [] }));
      } else if (err.status === 429) { // Not Found
        this.toastrService.warning('Too many requests');
        return of(new HttpResponse({ body: [] }));
      } else {
        const error = err.error.message || err.statusText;
        return throwError(error);
      }
    }));
    /* return next.handle(req).pipe(tap((event: HttpEvent<any>) => {
      if (event instanceof HttpResponse) {
      }
    },
      (error: any) => {
      }
    )); */
  }
  private addToken(request: HttpRequest<any>, token: string): HttpRequest<any> {
    return request.clone({
      setHeaders: {
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
        Pragma: 'no-cache',
        'Authorization': `Bearer ${token}`
      }
    });
  }
  private handle401Error(request: HttpRequest<any>, next: HttpHandler) {
    if (!this.isRefreshing) {
      this.isRefreshing = true;
      this.refreshTokenSubject.next(null); // Clear token subject while refreshing

      return this.authService.refreshToken(request).pipe(
        switchMap((newToken: any) => {
          this.isRefreshing = false;
          this.refreshTokenSubject.next(newToken); // New token is available
          // Retry the original request with the new token
          return next.handle(this.addToken(request, newToken.token));
        }),
        catchError((err) => {
          this.isRefreshing = false;
          this.authService.logout(); // Log out if refresh failed
          return throwError(() => err);
        })
      );
    } else {
      // Token refresh is already in progress, queue the failed request
      return this.refreshTokenSubject.pipe(
        filter(token => token !== null), // Wait until a token is emitted
        take(1), // Take the first non-null token
        switchMap(token => {
          // Retry the original request with the new token
          return next.handle(this.addToken(request, token.token));
        })
      );
    }
  }
}
